<template>
  <v-container v-if="fieldKey">
    <v-form v-model="valid">
      <v-row>
        <v-col cols="8">
          <text-field
            label="Name"
            :value="getValue(value, 'name')"
            @input="setValue(value, 'name', $event)"
            :readonly="readOnly"
          ></text-field>
        </v-col>
      </v-row>
      <v-row
        v-for="group in fields"
        v-bind:key="'row' + group[0].key"
      >
        <template
          v-for="field in group"
          cols="4"
        >
          <template v-if="!isFullWidth(field.type)">
            <v-col v-bind:key="field.key">
              <text-field
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='text'"
              ></text-field>
              <date-picker
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='date'"
              ></date-picker>
              <s-textarea
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='multiline'"
              ></s-textarea>
              <switch-button
                :label="field.label"
                :value="getValue(value, field.key)"
                @change="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='bool'"
              ></switch-button>
              <text-field
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='double'"
              ></text-field>
              <text-field
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='int'"
              ></text-field>
              <account-type
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :readonly="readOnly"
                v-if="field.type=='account_type'"
              ></account-type>
              <v-autocomplete
                v-if="field.type=='options'"
                :readonly="readOnly"
                :label="field.label"
                :value="getValue(value, field.key)"
                @input="setValue(value, field.key, $event)"
                :items="field.options"
                filled
                dense
              ></v-autocomplete>
            </v-col>
          </template>
          <template v-if="isFullWidth(field.type) && id">
            <v-col
              cols="12"
              v-bind:key="field.key"
            >
              <file-upload
                v-if="field.type=='fileupload'"
                :readonly="readOnly"
                module="codelist"
                :section="fieldKey"
                :label="field.label"
                :multi="true"
                :item_id="id"
                @input="setValue(value, field.key, $event)"
              >
              </file-upload>
            </v-col>
          </template>
        </template>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import consts from '@/components/codelist/defines/consts'
  import Utils from '@/utils'

  import TextField from '@/components/TextField'
  import ReactivityMixin from '@/mixins/Reactivity'
  import DatePicker from '@/components/DatePicker'
  import STextarea from '@/components/Textarea'
  import SwitchButton from '@/components/SwitchButton'
  import AccountType from '@/components/codelist/AccountType'
  import FileUpload from '@/components/FileUpload'
  export default {
    name: 'CodeListForm',
    mixins: [
      ReactivityMixin,
    ],
    props: {
      fieldKey: {
        default: undefined,
      },
      value: {
        default: {},
      },
      readOnly: {
        default: false,
      },
      id: { // set if we have exact item
        default: undefined,
      },
    },
    components: { FileUpload, AccountType, SwitchButton, STextarea, DatePicker, TextField },
    data () {
      return {
        fields: {},
      }
    },
    watch: {
      value: function () {
        this.prepareTypes()
      },
    },
    mounted () {
      this.prepareTypes()
    },
    methods: {
      prepareTypes () {
        Vue.set(this.value, 'meta_field_descr', {})
        const metaFields = consts.codeLists[this.fieldKey].meta
        for (const field of metaFields) {
          if (field.key.indexOf('meta_') < 0) {
            field.key = 'meta_' + field.key
          }
          Vue.set(this.value.meta_field_descr, field.key, {
            type: field.type,
          })
        }
        this.$emit('input', this.value)
        this.fields = Utils.splitArrayToGroups(metaFields)
      },
      isFullWidth (type) {
        return type === 'fileupload'
      },
    },
  }
</script>

<style scoped>

</style>
